import { Grid } from '@material-ui/core';
import { Form, FormikProps } from 'formik';
// @material-ui/icons
// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';
import Button from '@components/CustomButtons/Button';
import React, { useContext, useEffect, useMemo } from 'react';

import { UpdatePublisherInput as Input } from '../../types/eventsGlobalTypes';
import GoBackHeader from '@components/GoBackHeader/GoBackHeader';
import { itemFields } from '../constants';
import OVSForm from '@components/Form/OVSForm';
import { BrokerContext } from '../../broker/context/BrokerProvider';

const ItemForm: React.FC<{
  formBag: FormikProps<Input>;
  disableLoginButton: boolean;
}> = (props) => {
  const { formBag, disableLoginButton } = props;

  const { items, getItems } = useContext(BrokerContext);

  useEffect(() => {
    if (items.length === 0) {
      getItems();
    } // eslint-disable-next-line
  }, []);

  const formFieldsData = useMemo(
    () => [
      {
        name: '',
        fields: [
          {
            type: 'text',
            name: itemFields.topic,
            label: 'Topic',
          },
          {
            type: 'select',
            name: itemFields.broker,
            label: 'Broker',
            options: items?.map((it) => ({
              _id: it.node?._id || '',
              name: it?.node?.name || '',
            })),
            onChange: (e: any) => {
              formBag.setFieldValue(itemFields.broker, e.target.value);
            },
            value: formBag.values.broker || '',
          },
        ],
      },
    ], // eslint-disable-next-line
    [formBag.values, items]
  );
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <GoBackHeader />
        <Form>
          <GridContainer>
            <OVSForm formFieldsData={formFieldsData} />
          </GridContainer>
          <Grid>
            <Button
              color='primary'
              onClick={() => {
                formBag.submitForm();
              }}
              disabled={disableLoginButton}
            >
              Save
            </Button>
          </Grid>
        </Form>
      </GridItem>
    </GridContainer>
  );
};

export default ItemForm;
